import { IFormStep } from '../../utils/formStep';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import Notification from '../../../notification/notification';
import OrganizationStep2AdministratorProfile from './organizationStep2AdministratorProfile';
import fetchFormData from '../../../../helpers/fetchFormData';
import { userModelFromFormData } from '../../../../helpers/models/userModel';
import { updateUser } from '../../../../helpers/user';
import { updateAccount } from '../../../../helpers/account';
import { ELanguage } from '../../utils/language';
import { handleRequiredError, scrollToFormErrors } from '../../utils/formErrors';
import { IProvinceModel } from '../../../../helpers/models/provinceModel';
import { IRoleModel } from '../../../../helpers/models/roleModel';
import {
    IOrganizationStep2FormResultModel,
    OrganizationStep2FormResultKeys,
} from './organizationStep2FormModel';
import { startOverId } from '../../registration';

const OrganizationStep2 = (props: IFormStep) => {
    const { t, account, i18n } = props;
    const [data, setData] = useState(account);

    useEffect(() => {
        if (account && account.user) {
            setData(account);
        }
    }, [data]);

    const handleSubmitOrganizationStep2 = (e: any) => {
        e.preventDefault();
        const data = fetchFormData(e);
        const formResult = Object.assign(
            {},
            ...data.map((x) => ({ [x.name]: x.value }))
        ) as IOrganizationStep2FormResultModel;
        const administratorDetails = userModelFromFormData(formResult);
        const errorList = handleRequiredError(formResult, data, t);

        if (!errorList.length) {
            administratorDetails.lng =
                data.find(
                    (item) => item.name === OrganizationStep2FormResultKeys.LNG && item.checked
                )?.value === ELanguage.English.toString()
                    ? 'en'
                    : 'fr';

            // update user
            updateUser(i18n.language, account.id, administratorDetails);

            // update step in account
            const newFormData = Object.assign({}, account);
            if (newFormData.step >= 1) {
                newFormData.step++;
            }
            // set number to province and role instead of the returned object
            newFormData.province = +(account.province as IProvinceModel).id;
            newFormData.role = +(account.role as IRoleModel).id;

            updateAccount(i18n.language, account.id, { ...newFormData });
        }
        if (errorList.length) {
            props.setError(errorList);
            scrollToFormErrors();
        }
    };

    return (
        <div className="registration-organization_step_container">
            <Notification
                error={false}
                label={t('popover_aria_label', { ns: 'accessibility' })}
                messages={[{ message: 'form_organization_step_2_notice', weight: 0 }]}
            />
            <form className="registration-container" onSubmit={handleSubmitOrganizationStep2}>
                <OrganizationStep2AdministratorProfile account={data!} />
                <div className="registration-organization-button-container">
                    <button
                        className="button button--secondary registration-organization-button"
                        onClick={props.startOver}
                        id={startOverId}
                    >
                        {t('form_organization_step_2_button_restart')}
                    </button>
                    <div className="registration-organization-standalone-button-container">
                        <a
                            tabIndex={0}
                            data-step={2}
                            className="standalone-link registration-button-standalone-link registration-organization-standalone-link"
                            onClick={props.goBack}
                            role="button"
                        >
                            {t('form_organization_step_2_button_previous')}
                        </a>
                        <button
                            className="button button--primary registration-organization-button"
                            type="submit"
                        >
                            {t('form_organization_step_2_button_next')}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default withTranslation()(OrganizationStep2);
